import script from "./LoadingButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingButton.vue?vue&type=script&setup=true&lang=js"

import "./LoadingButton.vue?vue&type=style&index=0&id=1256d29e&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/reenarafiq/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1256d29e"]])

export default __exports__